import { Link } from "@tanstack/react-router";
import { cn } from "~/lib/utils";
import { Button } from "../ui/button";

function isExternalLink(href: string) {
  return (
    href.startsWith("http://") ||
    href.startsWith("https://") ||
    href.startsWith("mailto:") ||
    href.startsWith("tel:")
  );
}

export const ContentSection = ({
  children,
  eyebrow,
  description,
  id,
  title,
  link,
  linkLabel,
  backgroundColor = "white",
  className = "",
  titleAlign = "left",
}: {
  children: React.ReactNode;
  eyebrow?: string;
  description?: string;
  id?: string;
  title?: string;
  link?: string;
  linkLabel?: string;
  backgroundColor?: "white" | "lightgray";
  className?: string;
  titleAlign?: "left" | "center";
}) => {
  return (
    <div
      className={`${className} ${
        backgroundColor === "white" ? "bg-white" : "bg-neutral-lightest"
      } layout-place-full-width layout-content-grid py-10 md:py-20`}
    >
      {eyebrow ? (
        <h2
          className={cn(
            "text-base font-semibold mb-4",
            titleAlign === "center" ? "text-center" : "text-left",
          )}
        >
          {eyebrow}
        </h2>
      ) : null}
      {title ? (
        <div className="flex justify-between">
          <h2
            id={id}
            className={cn(
              "text-3xl md:text-5xl font-medium mb-5 w-full grow",
              id && "scroll-mt-20",
              titleAlign === "center" ? "text-center" : "text-left",
            )}
          >
            {title}
          </h2>
          {link && linkLabel ? (
            <p className="mb-8">
              <Button asChild variant="outline">
                {isExternalLink(link) ? (
                  <a href={link} target="_blank" rel="noopener noreferrer">
                    {linkLabel}
                  </a>
                ) : (
                  <Link to={link}>{linkLabel}</Link>
                )}
              </Button>
            </p>
          ) : null}
        </div>
      ) : null}
      <div
        className={cn(titleAlign === "center" ? "text-center" : "text-left")}
      >
        {description ? <p className="mb-8">{description}</p> : null}
        <div className="space-y-8">{children}</div>
      </div>
    </div>
  );
};
